export default class Galerie {
  constructor() {
    this.thumbnails = document.querySelectorAll('.galerie__content__image')
    this.galerie = document.querySelector('.galerie__content')

    this.lightbox = document.querySelector('.lightbox')
    this.lightboxNavigationClose = document.querySelector('.lightbox__navigation__close')
    this.lightboxImage = document.querySelector('.lightbox__image')
    this.lightboxFlag = true
    this.lightboxIndex

    this.lightboxArrowLeft = document.querySelector('.lightbox__navigation__arrow__left')
    this.lightboxArrowRight = document.querySelector('.lightbox__navigation__arrow__right')

    this.postID = document.querySelector('.post-id').textContent
    this.galleryData

    if (this.galerie) {
      this.init()
      this.clicks()
    }
  }

  init() {
    // Load JSON
    if (document.querySelector('.archiv-rocniku')) {
      fetch(`${document.location.origin}/wp-json/wp/v2/archiv-rocniku/${this.postID}`)
        .then((response) => response.json())
        .then((data) => (this.galleryData = data.acf.galerie))
    } else {
      fetch(`${document.location.origin}/wp-json/wp/v2/archiv-rocniku?orderby=title`)
        .then((response) => response.json())
        .then((data) => (this.galleryData = data[0].acf.galerie))
    }
    // Open
    this.thumbnails.forEach((image, index) => {
      image.addEventListener('click', () => {
        if (this.galleryData) {
          this.openLightbox(index)
          document.body.style.overflowY = 'hidden'
          //console.log(index)
        }
        this.lightboxFlag = false
      })
    })

    // Close
    this.lightboxNavigationClose.addEventListener('click', () => {
      this.closeLightbox()
      document.body.style.overflowY = 'scroll'
    })
  }

  openLightbox(imageIndex) {
    this.lightboxIndex = imageIndex
    this.lightbox.style.display = 'flex'
    this.lightboxImage.src = `${this.galleryData[imageIndex].full_image_url}`

    this.lightboxArrowRight.style.removeProperty('opacity')
    this.lightboxArrowRight.style.cursor = 'pointer'
    this.lightboxArrowLeft.style.removeProperty('opacity')
    this.lightboxArrowLeft.style.cursor = 'pointer'

    this.arrows()
  }

  closeLightbox() {
    this.lightbox.style.display = 'none'
  }

  arrows() {
    if (this.lightboxIndex <= 0) {
      this.lightboxArrowLeft.style.opacity = '0.25'
      this.lightboxArrowLeft.style.cursor = 'default'
    } else if (this.lightboxIndex >= this.galleryData.length - 1) {
      this.lightboxArrowRight.style.opacity = '0.25'
      this.lightboxArrowRight.style.cursor = 'default'
    }
  }

  clicks() {
    // Right
    this.lightboxArrowRight.addEventListener('click', () => {
      this.right()
    })
    // Left
    this.lightboxArrowLeft.addEventListener('click', () => {
      this.left()
    })
  }

  right() {
    this.lightboxIndex++
    this.lightboxArrowLeft.style.removeProperty('opacity')
    this.lightboxArrowLeft.style.cursor = 'pointer'

    if (this.lightboxIndex >= this.galleryData.length - 1) {
      this.lightboxArrowRight.style.opacity = '0.25'
      this.lightboxArrowRight.style.cursor = 'default'
      this.lightboxImage.src = `${this.galleryData[this.galleryData.length - 1].full_image_url}`
      this.lightboxIndex = this.galleryData.length - 1

      // console.log(this.lightboxIndex)
    } else {
      this.lightboxImage.src = `${this.galleryData[this.lightboxIndex].full_image_url}`
      // console.log(this.lightboxIndex)
    }
  }

  left() {
    this.lightboxIndex--
    this.lightboxArrowRight.style.removeProperty('opacity')
    this.lightboxArrowRight.style.cursor = 'pointer'

    if (this.lightboxIndex <= 0) {
      this.lightboxArrowLeft.style.opacity = '0.25'
      this.lightboxArrowLeft.style.cursor = 'default'
      this.lightboxImage.src = `${this.galleryData[0].full_image_url}`
      this.lightboxIndex = 0

      // console.log(this.lightboxIndex)
    } else {
      this.lightboxImage.src = `${this.galleryData[this.lightboxIndex].full_image_url}`
      // console.log(this.lightboxIndex)
    }
  }
}
